import React, { useState, useEffect } from "react";
import aboutImg from "../../Assets/about.jfif";
import Footer from "../../Components/Footer/Footer";
import "./About.css";
import Images from "../../utils/images";

const About = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    window.scrollTo(0, 0);
    return () => clearTimeout(timer);
  }, []);

  const videoData = [
    {
      videoUrl:
        "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/SJM%20VMB_2025-08-21T11-27-38-028Z.mp4",
    },
    {
      videoUrl:
        "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/VMB%20HLP_2025-08-21T11-28-54-896Z.mp4",
    },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-white">
      {/* Main Content */}
      <div className="about_container px-4 py-32">
        <div className="text-center">
          {/* <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary py-4">{Strings.ABOUT}</h1>  */}
          <p className="font-jost text-shadow mx-auto w-full py-16 text-base font-bold text-white sm:w-[80%] sm:text-lg md:w-[60%] md:text-xl lg:w-[50%]">
            Vivāha-yajña, the marriage ceremony, is meant to regulate the human
            mind so that it may become peaceful for spiritual advancement. For
            most men, this vivāha-yajña should be encouraged even by persons in
            the renounced order of life.
          </p>
        </div>
      </div>
      <section className="mx-auto w-[95%] py-8">
        <div className="font-jost py-7 text-3xl">
          <p className="text-primary text-center text-2xl">About Us</p>
          <div className="mx-auto mt-2 w-16 border-b-2 border-yellow-400 text-center" />
          <p className="text-secondary pt-4 text-center text-2xl">
            Connecting Hearts, Guided by Devotion
          </p>
          <div className="mx-auto w-[180px] border-b-2 border-yellow-400 pt-2 text-center" />
        </div>

        <div className="content font-jost flex flex-col gap-6 lg:flex-row">
          <div className="content-section lg:w-1/3">
            <p className="mb-4 pt-8 text-justify text-gray-700">
              At <b>Vaisnava Marriage Bureau</b>, We believe that marriage is
              not just a union of two individuals but the forging of a sacred
              bond in Krishna Consciousness.
            </p>
            <p className="text-justify text-gray-700">
              <b>Our Mission:</b> Our platform is dedicated to helping you find
              your dream life partner—someone who inspires, strengthens, and
              shares your values in Krishna Consciousness for a meaningful,
              fulfilling, and active life together. We create a safe and
              supportive space for you to connect, converse, and ultimately find
              your life partner. We understand the significance of marrying a
              devotee and we are committed to facilitating unions that honor the
              teachings of Srila Prabhupada.
            </p>
          </div>

          <div className="image-section flex items-center justify-center lg:w-1/3">
            <img
              src={Images.ABOUTUS}
              alt="about"
              className="h-[350px] rounded-lg shadow-lg"
            />
          </div>
          <div className="content-section lg:w-1/3">
            <p className="mb-4 pt-8 text-justify text-gray-700">
              <b>Our Values:</b> We uphold the highest standards of honesty,
              transparency, and respect in all interactions.We strive to build a
              strong, supportive community in Krishna Consciousness.
            </p>
            <p className="text-justify text-gray-700">
              <b>Our Story:</b> Vaisnava Marriage was created by a group of
              dedicated couples, inspired and guided by HH Jayapataka, who
              recognized the need for a specialized platform that caters to the
              unique needs of devotees. With a deep understanding of the
              importance of shared values in marriage, they set out to create a
              service that goes beyond simple matchmaking, facilitating unions
              that honor the teachings of Srila Prabhupada.
            </p>
          </div>
          <div className="max-w-6x2 mx-auto grid grid-cols-1 gap-8 pb-10 sm:grid-cols-2"></div>
        </div>
      </section>
      <div className="flex items-center justify-center pb-20 pt-10 md:pt-20 pl-2 pr-2">
        <div className="grid w-full grid-cols-1 gap-2 pb-10 md:grid-cols-2">
          {videoData.map((video, index) => (
            <div key={index} className="flex justify-center">
              <video
                controls
                className="mb-3 h-80 w-full rounded-md border-4 border-yellow-400 object-cover md:w-[80%]"
              >
                <source src={video.videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;
